import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import TopicPageEditorPost from "../TopicPageEditorPost";
import TopicPageEditorDivider from "../TopicPageEditorDivider";
import { useTopicPageViewsTopicEditor } from "./TopicPageViewsTopicEditorContext";
const TopicPageViewsTopicEditors = (props)=>{
    const { topicId , topicNodeId , context , afterItemId  } = props;
    const { state , dispatch  } = useTopicPageViewsTopicEditor();
    const { editor , editorPosition  } = state;
    const closeEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    const match = editorPosition === (afterItemId === null ? topicId : afterItemId);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageEditorPost, {
                context: context,
                topicId: topicId,
                topicNodeId: topicNodeId,
                afterItemId: afterItemId,
                closeEditor: closeEditor,
                open: editor === "CREATE_POST" && match ? state.variant : undefined
            }),
            /*#__PURE__*/ _jsx(TopicPageEditorDivider, {
                context: context,
                topicId: topicId,
                topicNodeId: topicNodeId,
                afterItemId: afterItemId,
                closeEditor: closeEditor,
                open: editor === "CREATE_DIVIDER" && match ? state.variant : undefined
            })
        ]
    });
};
export default TopicPageViewsTopicEditors;
